import type { MigrationManifest, PersistConfig, PersistMigrate } from 'redux-persist';
import { createMigrate, getStoredState } from 'redux-persist';
import type { WebStorage } from 'redux-persist/es/types';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';

import type { FeatureRollout, YammerState } from '../state/types';

export { createMigrate };
export type { FeatureRollout, MigrationManifest };

export interface GetPersistConfigProps {
  readonly key: string;
  readonly version?: number;
  readonly migrate?: PersistMigrate;
  readonly allowlist?: (keyof YammerState)[];
}

// this provides a fallback noop storage option for non-browser environments, namely jest's node test environment
let noopStorage: WebStorage;
export const getNoopStorage = () => {
  if (noopStorage) {
    return noopStorage;
  }
  noopStorage = {
    getItem() {
      return Promise.resolve(null);
    },
    setItem() {
      return Promise.resolve();
    },
    removeItem() {
      return Promise.resolve();
    },
  };

  return noopStorage;
};

type GetPersistConfig = <T extends YammerState>(props: GetPersistConfigProps) => PersistConfig<T>;
export const getPersistConfig: GetPersistConfig = ({ key, version, migrate, allowlist = [] }) => ({
  storage: typeof window !== 'undefined' ? createWebStorage('local') : getNoopStorage(),
  key,
  version,
  migrate,
  whitelist: allowlist,
});

export type GetPersistedState = (key: string) => Promise<Partial<YammerState> | undefined>;
export const getPersistedState: GetPersistedState = async (key) => getStoredState(getPersistConfig({ key }));
